function waitForElement(selector1, selector2, callback) {
  var header = document.querySelector(selector1);
  var menuButton = document.querySelector(selector2);

  if (header && menuButton) {
    return callback(header, menuButton);
  }

  setTimeout(function () {
    waitForElement(selector1, selector2, callback);
  }, 100);
}

function waitForAllElements(selector, callback) {
  var elements = document.querySelectorAll(selector);

  if (elements) {
    return callback(elements);
  }

  setTimeout(function () {
    waitForAllElements(selector, callback);
  }, 100);
}

function toggleHeader() {
  var menuItems = document.querySelectorAll(".menu-item");
  waitForElement(".main-header", ".menu-button", function (header, menuButton) {
    menuButton.addEventListener("click", function () {
      header.classList.toggle("is-active");

      if (!header.classList.contains("is-active")) {
        menuItems.forEach(function (item) {
          item.classList.remove("is-active");
        });
      }
    });
  });
}

function toggleAccordion() {
  var accordionItems = document.querySelectorAll(".accordion");

  accordionItems.forEach(function (item) {
    item.addEventListener("click", function () {
      item.classList.toggle("is-active");
    });
  });
}

toggleHeader();
toggleAccordion();